export default __webpack_public_path__ + "static/media/wallets2-removebg-preview.af4d2228.png";